import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-transportforlondon',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Transport for London icon</title><path d="M12 2.25a9.73 9.73 0 0 0-9.49 7.5H0v4.5h2.51a9.73 9.73 0 0 0 9.49 7.5c4.62 0 8.48-3.2 9.49-7.5H24v-4.5h-2.51A9.73 9.73 0 0 0 12 2.25zM12 6c2.5 0 4.66 1.56 5.56 3.75H6.44A6.02 6.02 0 0 1 12 6zm-5.56 8.25h11.12A6.02 6.02 0 0 1 12 18a6.02 6.02 0 0 1-5.56-3.75Z"/></svg>`,
    styles: []
})
export class SimpleIconsTransportforlondonComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#00B274';
    @Input() className: string = 'simple-icons-transportforlondon'
    constructor() {}
    ngOnInit(): void {}
}
